<template>
  <div id="pageCourseList" class="container">
    <v-container grid-list-xl fluid class="mx-auto">
      <v-layout row wrap>
        <v-flex sm12>
          <h2>Meus Cursos</h2>
        </v-flex>
        <template v-if="loading">
          <v-skeleton-loader
            v-for="i in 3"
            transition="scale-transition"
            width="360"
            type="card"
            class="mx-2"
          >
          </v-skeleton-loader>
        </template>
        <template v-else>
          <v-flex xs12 sm6 lg4 xl3 v-for="(e, i) in enrollments" :key="e.id">
            <v-card
              class="rounded-xl d-flex flex-column"
              :disabled="!e.hasOfflineSupport && isOffline"
              :class="{ 'expired-card': e.is_expired }"
              @click="!e.is_expired && goToCourse(e)"
              style="height: 520px"
            >
              <v-img
                :src="e.course.background_image"
                height="200px"
                class="rounded-t-xl"
              >
              </v-img>
              <div class="pa-5 d-flex flex-column" style="height: 320px">
                <div style="height: 160px">
                  <h2 class="text-h4">
                    {{ e.course.course }}
                  </h2>
                  <div class="mt-2 description">
                    {{ e.course.description }}
                  </div>
                </div>
                <div class="d-flex flex-column" style="flex: 1">
                  <div class="row-space-between mb-4">
                    <div class="coluna grey--text">
                      <span v-if="e.is_expired">expirado</span>
                      <span v-else>expira em</span>
                      <span v-if="!e.is_expired">{{ e.expiration_date }}</span>
                    </div>
                    <div class="coluna align-end">
                      <span class="grey--text">seu progresso</span>
                      <span v-if="loading" class="span-enfase">-%</span>
                      <span v-else class="span-enfase">
                        {{
                          e.course && e.course.user_progress
                            ? e.course.user_progress.percentage
                            : 0
                        }}%
                      </span>
                    </div>
                  </div>
                  <div class="mt-auto">
                    <template v-if="!e.is_expired">
                      <template v-if="e.is_near_expiration">
                        <v-btn
                          rounded
                          outlined
                          color="secondary"
                          class="elevation-0 py-4 mb-2"
                          style="
                            font-size: 16px;
                            font-weight: bold;
                            width: 100%;
                          "
                          @click.stop="goToExtending(e)"
                        >
                          Prorrogar
                        </v-btn>
                      </template>
                      <v-btn
                        rounded
                        color="primary"
                        class="elevation-0 py-4"
                        style="font-size: 16px; font-weight: bold; width: 100%"
                        @click.stop="goToCourse(e)"
                      >
                        Aprender
                      </v-btn>
                    </template>
                    <template v-else>
                      <v-btn
                        v-if="e.course.extending_allowed"
                        rounded
                        outlined
                        color="secondary"
                        class="elevation-0 py-4"
                        style="font-size: 16px; font-weight: bold; width: 100%"
                        @click.stop="goToExtending(e)"
                      >
                        Prorrogar
                      </v-btn>
                    </template>
                  </div>
                </div>
              </div>
            </v-card>
          </v-flex>
        </template>
      </v-layout>
      <message-card
        v-if="this.enrollments.length === 0"
        title="Ué!! Cadê?"
        subtitle="Não encontramos nenhuma matrícula em seu usuário"
        icon="/img/mind.svg"
        :cta="{ title: 'Cursos Disponíveis', route: 'shop' }"
      >
      </message-card>
    </v-container>
  </div>
</template>

<script>
import EnrollmentService from "../../services/enrollments.service";
import MessageCard from "../../components/widgets/card/MessageCard";
import { CONFIG } from "@/config";

export default {
  components: {
    MessageCard,
  },
  metaInfo: {
    title: "LS",
    titleTemplate: "%s - Meus Cursos",
    htmlAttrs: {
      lang: "pt-br",
      amp: false,
    },
  },
  data() {
    return {
      show: true,
      loading: true,
      enrollments: [{}],
      isOffline: !navigator.onLine,
    };
  },
  mounted() {
    window.addEventListener("offline", () => {
      this.isOffline = true;
    });
    window.addEventListener("online", () => {
      this.isOffline = false;
    });
    this.$store.dispatch("clearCourse");
    try {
      // adiciona as entradas da api no cache
      caches.open(CONFIG.CACHEV).then(function (cache) {
        return cache.addAll(["/courses"]);
      });
    } catch (error) {
      console.log("erro ao cachear", error);
    }
    this.loadCourses();
  },
  methods: {
    loadCourses() {
      EnrollmentService.getMyCourses(true, "course.user_progress")
        .then(async (response) => {
          this.enrollments = await Promise.all(
            response.data.map(async (enrollment) => {
              return {
                ...enrollment,
                hasOfflineSupport:
                  undefined !==
                  (await caches.match(
                    "/courses/" +
                      enrollment.course.id +
                      "/" +
                      enrollment.course.slug,
                  )),
              };
            }),
          );
          this.loading = false;
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = false;
        });
    },

    goToCourse(enrollment) {
      if (enrollment.accepted_by_user) {
        this.$router.push({
          name: "student-area",
          params: {
            courseId: enrollment.course.id,
            slug: enrollment.course.slug,
          },
        });
      } else {
        this.$router.push({
          name: "contract.agreement",
          params: {
            courseId: enrollment.course.id,
            enrollmentId: enrollment.id,
          },
        });
      }
    },
    goToExtending(enrollment) {
      this.$router.push({
        name: "extending",
        params: {
          courseId: enrollment.course.id,
          enrollmentId: enrollment.id,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.coluna {
  display: flex;
  flex-direction: column;
  line-height: 1;
  .span-enfase {
    font-size: 26px;
    font-weight: 600;
    color: var(--v-primary-base);
  }
}
.row-space-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
h2.text-h4 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Description truncation with fixed height */
.description {
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  font-size: 18px;
  height: 75px;
}
.mt-45 {
  margin-top: -45px;
}

.mt-56 {
  margin-top: -56px;
}

.v-card__actions {
  a {
    text-decoration: none;
  }
}
.expired-card {
  opacity: 0.7;
  background-color: #f5f5f5;
  cursor: not-allowed;
}
.expired-card .v-btn {
  opacity: 1 !important;
  color: black !important;
  border-color: black !important;
}
.expired-layout {
  justify-content: flex-end;
  margin-top: auto;
}
.buttons-container {
  display: flex;
  flex-direction: column;
  margin-top: auto;
  height: 56px;
  justify-content: flex-end;

  &.two-buttons {
    height: 112px;
    margin-top: 0;
  }

  &.single-button {
    margin-top: auto;
  }
}
</style>
